import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=6d5bc003&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=6d5bc003&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5bc003",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5bc003')) {
      api.createRecord('6d5bc003', component.options)
    } else {
      api.reload('6d5bc003', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=6d5bc003&scoped=true", function () {
      api.rerender('6d5bc003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/ScrollPane.vue"
export default component.exports